import { gql } from "apollo-angular";

export default gql`
  mutation ResendOtp($input: ResendOtpInput!) {
    resendOtp(input: $input) {
      otpId
      userId
    }
  }
`;
